import { Button, Box, Typography, Stack } from '@mui/material';
import { useDeleteOperator, useGetOperators } from 'apis/business/setting/operator/hook';
import { GoPlus } from 'react-icons/go';
import Pagination, { usePagination } from 'components/Common/Pagination';
import OperatorCard from './Components/OperatorCard';
import { useNavigate } from 'react-router-dom';
import { EmptyStateView } from '@/components/Common/EmptyStateView';
import OperatorCardsSkeleton from './Components/OperatorCardSkeleton';

export default function Operator() {
  const navigate = useNavigate();
  const { currentPage, perPage, setPage, setPerPage } = usePagination();
  const { data: operators, isLoading } = useGetOperators({ page: currentPage, per_page: perPage });
  const { mutate: deleteOperator } = useDeleteOperator();

  return (
    <>
      <Box display='flex' justifyContent='space-between' alignItems='center' mb={3}>
        <Typography variant='h6' fontWeight={500}>
          Operator
        </Typography>

        <Button onClick={() => navigate('add')} variant='contained' startIcon={<GoPlus />}>
          Add Operator
        </Button>
      </Box>

      {isLoading || operators?.data?.length ? (
        <Stack spacing={2}>
          {isLoading ? (
            <OperatorCardsSkeleton />
          ) : (
            operators?.data?.map((operator: any, idx: number) => (
              <OperatorCard
                key={operator.id}
                idx={idx}
                operator={operator}
                onEdit={() => navigate(String(operator.id))}
                onDelete={() => deleteOperator(String(operator.id))}
              />
            ))
          )}
        </Stack>
      ) : (
        <Box mt={10}>
          <EmptyStateView message='No Operator Found' />
        </Box>
      )}

      <Pagination
        totalPages={operators?.meta?.total_pages}
        totalCount={operators?.meta?.total_count ?? 0}
        currentPage={currentPage}
        perPage={perPage}
        onChange={setPage}
        onPerPageChange={setPerPage}
      />
    </>
  );
}
